/**
 * Ширината на дясната колона в „Маркиране" — „Преглед на поръчката" в менюто
 * (`menu/OrderPanel`) и панелът на избраната маса в режим „Схема"
 * (`tables/schema/SchemaTablePanel`) са еднакво широки. Процентът е от целия
 * ред (и в двата случая — цялата ширина на екрана).
 */
export const SIDE_PANEL_WIDTH_CLASS = "w-[clamp(300px,27%,388px)]";
